import {useParams} from 'react-router-dom';
import Header from '../../../components/header';
import UseGetStoreInfo from '../hooks/useGetStoreInfo';
import StoreHeader from '../../../module/store/header';
import DotsLoading from '../../../components/dotsLoading';
import ShopPosts from '../../../module/shop/posts';
import EmptyImage from '../../../assets/image/shared/empty.svg';

import UseGetShopProducts from '../../shop/products/hooks/useGetShopPosts';

const Store = () => {
  const params = useParams();

  const {storeInfo, isLoading, isSuccess} = UseGetStoreInfo(params?.guid || '');
  const {
    data,
    fetchNextPage,
    isLoading: postLoading,
  } = UseGetShopProducts(params?.supplier_id || '');

  return (
    <>
      <div className="px-3">
        <Header showBackBtn={true} title={storeInfo?.title || ''} />
        {isLoading && !isSuccess ? (
          <DotsLoading />
        ) : (
          <>
            <StoreHeader
              title={storeInfo?.title || ''}
              address={
                storeInfo?.state.state_name + '،' + storeInfo?.city.city_name
              }
              image={storeInfo?.logo || EmptyImage}
            />
            <div className="mt-4">
              <p className="text-justify color-gray-1 text-break">
                {storeInfo?.about}
              </p>
            </div>
          </>
        )}

        <div className="pt-3">
          <h5>آگهی ها</h5>
        </div>
        <ShopPosts
          data={data}
          fetchNextPage={fetchNextPage}
          isLoading={postLoading}
          hideManageInfo
        />
      </div>
    </>
  );
};

export default Store;
